import { render, staticRenderFns } from "./Revisao.vue?vue&type=template&id=f4b2273a&lang=pug&"
import script from "./Revisao.vue?vue&type=script&lang=js&"
export * from "./Revisao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports